import React, { useEffect, useState } from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { api, endpoints } from "@/lib/api";

export const TeamGrid = () => {
  const [team, setTeam] = useState([]);
  useEffect(() => { api.get(endpoints.team).then(setTeam).catch(() => {}); }, []);
  return (
    <section id="team" className="bg-background">
      <div className="container-wide py-16 lg:py-24">
        <SectionHeader eyebrow="Our Team" title="Public-service veterans building modern impact." lead="CAF is led by professionals with deep experience in civic administration, development, medicine, finance and technology." />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {team.map((m, i) => (
            <Reveal key={m.id} delay={i * 0.05}>
              <div className="rounded-xl border border-[hsl(var(--border))] overflow-hidden bg-card card-lift" data-testid={`team-member-card-${m.id}`}>
                <div className="aspect-[4/3] overflow-hidden"><img loading="lazy" src={m.image} alt={m.name} className="h-full w-full object-cover" /></div>
                <div className="p-5">
                  <h3 className="heading-3 text-lg">{m.name}</h3>
                  <div className="text-sm text-[hsl(var(--green))] font-semibold">{m.role}</div>
                  <p className="text-sm text-[hsl(var(--muted-ink))] mt-2">{m.bio}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
